import React, { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { ChakraAutocompleteField } from 'app/components/Core';
import { ContentContainerType } from 'types/enums';
import { ddlToOptions } from 'app/utils/utils';
import { getUpdateVersionValidationSchema } from 'app/components/Releases/SoundCloudVersionDetailsForm/utils';
import { Box, Grid, GridItem } from '@chakra-ui/react';
import { ContentContainer } from 'app/components/Core/ChakraContentContainer';
import { getDefaultValues } from './utils';
import {
  SoundCloudVersionDetailsFormComponentProps,
  SoundCloudVersionDetailsFormData,
} from './types';
import { ReleaseActions } from '../ReleaseActions';

export const SoundCloudVersionDetailsFormComponent: React.FC<SoundCloudVersionDetailsFormComponentProps> = ({
  releaseVersion,
  versionValidations,
  genresDDL,
  fetchAudioDetailsValidations,
  updateAudioValidations,
  primaryAudio,
  isSyncing,
}) => {
  const defaultValues = useMemo(
    () => getDefaultValues(releaseVersion, genresDDL),
    [releaseVersion, genresDDL]
  );
  const genres = useMemo(() => ddlToOptions(genresDDL, true), [genresDDL]);

  const { control } = useForm<SoundCloudVersionDetailsFormData>({
    defaultValues,
    mode: 'all',
    shouldFocusError: false,
    resolver: yupResolver(getUpdateVersionValidationSchema(versionValidations)),
  });

  useEffect(() => {
    if (!updateAudioValidations && primaryAudio?.audioData.guid) {
      fetchAudioDetailsValidations(primaryAudio.audioData.guid);
    }
  }, [updateAudioValidations, primaryAudio, fetchAudioDetailsValidations]);

  return (
    <ContentContainer type={ContentContainerType.LIST} pb={24}>
      <ReleaseActions tab="details" syncState={isSyncing} />
      <Box>
        <Grid
          templateColumns="repeat(4, 1fr)"
          columnGap={4}
          maxW="640"
          m="auto"
        >
          <GridItem colSpan={{ base: 4 }}>
            <ChakraAutocompleteField
              control={control}
              value={defaultValues.genre}
              name="genre"
              label="Genre"
              options={genres}
              isDisabled
            />
          </GridItem>
        </Grid>
      </Box>
    </ContentContainer>
  );
};
